module.exports = __webpack_public_path__ + "img/banner.20475f5a.jpg";